export default __webpack_public_path__ + "static/media/jibon-desktop-one.100aa64a.png";